import { useEffect, useRef } from "react";

import { SHORT_URL_EVENTS } from "@/modules/tracking/consts/Events";
import { ShortUrlFlow } from "@/modules/tracking/consts/ShortUrl";
import { readSourceFromLocation } from "@/modules/tracking/utils/readSourceFromLocation";
import { trackShortUrlEvent } from "@/modules/tracking/utils/trackShortUrlEvent";

type UsePageLoadedPayload = {
  flow: ShortUrlFlow;
  session_id: string | null;
  coach_id: string | number | null;
  time_until_session_start_minutes: number | null;
  is_first_visit: boolean;
  has_joined_previously: boolean;
};

export function usePageLoaded(payload: UsePageLoadedPayload): void {
  const fired = useRef(false);

  useEffect(() => {
    if (fired.current) return;
    fired.current = true;

    trackShortUrlEvent(SHORT_URL_EVENTS.PAGE_LOADED, {
      ...payload,
      source: readSourceFromLocation(),
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
